import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {openRefs: false, start: true}
    },
    {
        path: '/projekte',
        name: 'Projekte',
        component: Home,
        meta: {start: true, openRefs: true}
    },
    {
        path: '/team',
        name: 'Team',
        component: Home,
        meta: {openRefs: false, team: true}
    },
    {
        path: '/kontakt',
        name: 'Kontakt',
        component: Home,
        meta: {openRefs: false, kontakt: true}
    },
    {
        path: '/ueberuns/:slide',
        name: 'Slides',
        component: Home,
        meta: {openRefs: false, slides: true}
    },
  {
        path: '/projekte/:project',
        name: 'Projekt',
        component: Home,
        meta: {openRefs: false, singleRef: true}
    },
    {
        path: '/:slug',
        name: 'Page',
        component: Home,
        meta: {openRefs: false, defPage: true}
    }
]

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior() {
        document.getElementById('app').scrollIntoView();
    }
})

export default router
